import React, { Suspense } from 'react'
import AppRoutes from './layouts/navigation/AppRoutes'
import { ComponentNavigation } from './layouts/navigation/ComponentNavigation'
import PageLoader from './components/ui/pageLoader/PageLoader'
import { AdminPath } from './utils/AppSetting'

const App = () => {
  if (window.location.hostname.endsWith('.amplifyapp.com')) {
    let host = AdminPath;
    window.location.replace( host + window.location.pathname + window.location.search );
  }
  return (
    <Suspense fallback={<PageLoader />}>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </Suspense>
  )
}

export default App 